<template>
    <div id="div1">
        <div id="div4">
            <div id="div2">
                <img src="../../assets/img/about/5.png" alt="" class="img-1">
                <img src="../../assets/img/about/6.png" alt="" class="img-2">
                <img src="../../assets/img/about/7.png" alt="" class="img-2">
                <img src="../../assets/img/about/8.png" alt="" class="img-3">
                <img src="../../assets/img/about/9.png" alt="" class="img-3">
                <img src="../../assets/img/about/10.png" alt="" class="img-3">
                <img src="../../assets/img/about/11.png" alt="" class="img-3">
            </div>
            <div id="div3"></div>
            <!--这个容器是用来防止图片滚动时会出现空白的区域-->
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {}
        },
        created() {
            window.onload = function () {
                var v1 = document.getElementById('div1');
                var v2 = document.getElementById('div2');
                var v3 = document.getElementById('div3');
                v3.innerHTML = v2.innerHTML;//将v2容器里面的图片插入到v3容器里面  使其空白区域被遮住。
                function fun() {
                    if (v3.offsetWidth - v1.scrollLeft <= 0) {
                        v1.scrollLeft -= v2.offsetWidth;
                    } else {
                        v1.scrollLeft++;
                    }
                }
                var fun1 = setInterval(fun,40);
            }
        },
    }
</script>
<style type="text/css" scoped>
    * {
        margin: 0;
        padding: 0;
    }

    img {
        float: left;
        margin-right: 10px;
    }

    .img-1 {
        width: 1.7rem;
        height: 1.31rem;
    }

    .img-2 {
        width: 0.9rem;
        height: 1.21rem;
        margin-top: 0.1rem;
    }

    .img-3 {
        width: 0.9rem;
        height: 1.21rem;
        margin-top: 0.1rem;
    }

    #div1 {
        width: 100%;
        height: 1.25rem;
        overflow: hidden;
        margin-top: 0.07rem;
    }

    #div2,
    #div3 {
        float: left;
    }

    #div4 {
        width: 5000%;
        /*这个属性很重要 让容器有足够的宽度实现滚动*/
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/views/common/book.vue